<!--suppress XmlDuplicatedId -->
<ng-container *ngrxLet="vm$ as vm">
  @if (vm.loading) {
    <full-page-spinner></full-page-spinner>
  } @else if (!vm.loading) {
    <se-fe-page
      [seFeDataLoaded]="true"
      SeFeDataWidth="full"
      [seFeDataBackLink]="vm.backLink.backLink"
      [seFeDataBackQueryParams]="vm.backLink.backLinkParams"
      seFeDataBackText="Back"
      class="se-product-management product-detail"
      id="se-product-management">
      <div seFePageHeader>
        <se-fe-header [seFeDataTitle]="vm.product?.name ?? ''" size="750"></se-fe-header>
      </div>
      <div seFePageContent>
        @for (warning of warningData(); track warning.header) {
          <se-fe-alert seFeDataType="warning" class="product-detail__inactive-alert">
            {{ warning.header }}
            <se-fe-alert-subheader>
              {{ warning.subheader }}
            </se-fe-alert-subheader>
          </se-fe-alert>
        }
        <se-fe-grid>
          <se-fe-grid-cell id="product-detail__wide-cards" seFeGridOpts="1/3">
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <item-details-card
                  [cardName]="'Product details'"
                  [product]="vm.product"
                  [price]="vm.price ?? 0"
                  [error]="vm.error"
                  [productName]="vm.product?.name ?? ''"
                  [itemNumber]="vm.product?.id"
                  [productDescription]="vm.product?.description"
                  (updateProductAndPriceBreak)="updateProductAndPriceBreak($event)"></item-details-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <item-media-card
                  [product]="vm.product"
                  [error]="vm.error"
                  [image]="vm.image"
                  [images]="vm.images"
                  [allowMultipleImages]="true"
                  (updateProductImageAndDescription)="updateProductImageAndDescription($event)"
                  (setError)="setError($event)"></item-media-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <se-fe-card>
                  <se-fe-card-header seFeDataTitle="Product variants" [seFeDataHeavyBorder]="true">
                    <div seFeCardHeaderActions>
                      <product-specs-modal
                        #specsModalComponent
                        [showTrigger]="false"
                        [specs]="vm.specs"
                        [variants]="vm.variants"
                        [error]="vm.error"
                        (save)="updateSpecs($event)"></product-specs-modal>
                      <product-inventory-modal
                        #inventoryModalComponent
                        [showTrigger]="false"
                        [productId]="vm.product?.id ?? ''"
                        [variants]="vm.variants"
                        (inventoryUpdated)="updateVariantInventory($event)"></product-inventory-modal>
                      <se-fe-icon-button [seFeMenuTrigger]="variantActions">
                        <se-fe-icon
                          seFeDataName="edit"
                          seFeDataSize="500"
                          seFeDataAriaLabel="Edit product variants"></se-fe-icon>
                      </se-fe-icon-button>
                      <se-fe-menu #variantActions [seFeDataOptions]="variantMenuOptions"></se-fe-menu>
                    </div>
                  </se-fe-card-header>
                  <se-fe-card-content id="product-detail__product-variant">
                    @if (vm.variants.length > 0) {
                      <product-detail-variants
                        [variants]="vm.variants"
                        [specs]="vm.specs"
                        [product]="vm.product"
                        (updateVariantStatus)="updateVariantStatus($event)"></product-detail-variants>
                    } @else {
                      <se-fe-empty-state seFeDataTitle="No variants for this product" class="variant-empty-state">
                        <img
                          seFeEmptyStateIcon
                          src="../../../../../assets/images/spot_t-shirts.png"
                          alt="t-shirts logo" />
                        <p class="variant-empty-state__content">
                          Variants allow you to sell products that have more than one option, like size and color. When
                          you add variant options, we will automatically create the variants for you.
                        </p>
                        <se-fe-button
                          class="variant-empty-state__button"
                          seFeDataEmphasis="high"
                          (click)="openSpecsModal()">
                          Add variant options
                        </se-fe-button>
                      </se-fe-empty-state>
                    }
                  </se-fe-card-content>
                </se-fe-card>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
          <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts="1/4">
            <se-fe-grid id="product-detail__product-status" seFeGridOpts="snug">
              <se-fe-grid-cell seFeGridOpts>
                <se-fe-card>
                  <se-fe-card-header seFeDataTitle="Product status" [seFeDataHeavyBorder]="true"></se-fe-card-header>
                  <se-fe-card-content>
                    @if (chipState(); as chipState) {
                      <span [seFeMenuTrigger]="attrMenu">
                        <se-fe-chip
                          [seFeMenuTrigger]="attrMenu"
                          [seFeDataText]="chipState.text"
                          [seFeDataStyle]="chipState.style"
                          [seFeDataDisabled]="chipState.disabled"
                          [seFeDataFocusableOnDisabled]="true"
                          [seFeDataLoading]="vm.statusUpdating ?? false"
                          seFeDataIconLeft="dot_fill"
                          seFeMenuTriggerElement></se-fe-chip>
                      </span>
                      <se-fe-menu #attrMenu [seFeDataOptions]="productStatusMenuOptions"></se-fe-menu>
                    }
                  </se-fe-card-content>
                </se-fe-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="snug">
              <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts>
                <item-org-card
                  [editable]="true"
                  [brandName]="vm.brandName"
                  [taxCode]="vm.product?.tax_code"
                  [vendorName]="vm.vendorName"
                  [catalogs]="vm.catalogs"
                  [catalogsLoading]="vm.catalogsLoading"
                  [organizationCatalogs]="vm.organizationCatalogs"
                  [organizationCatalogsLoading]="vm.organizationCatalogsLoading"
                  [organizationId]="vm.organizationId"
                  (organizationCatalogsRequested)="loadOrganizationCatalogs()"
                  (updateProductBrand)="saveProductOrganization($event)"></item-org-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="snug">
              <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts>
                <product-bundling-card
                  [bundles]="vm.bundles"
                  [organizationId]="vm.organizationId"
                  [onlySoldInBundles]="vm.onlySoldInBundles"
                  [loading]="vm.onlySoldInBundlesUpdating ?? false"
                  [isInBundle]="vm.bundles.length > 0"
                  (onlySoldInBundlesChange)="updateOnlySoldInBundles($event)"></product-bundling-card>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
        </se-fe-grid>
      </div>
    </se-fe-page>
  }
</ng-container>
